import React, { memo, useEffect, useState } from 'react'
import SuperSearchList from '../../../shared/SuperSearch/SuperSearchList'
import { SimpleQuestionIcon } from '../../../shared/IconsComponent/icons'
import useDashboardFilterHook from '../Shared/useDashboardFilterHook'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import { enumUtil } from '../../../../utils/Enum'
import CalendaRangeInput from '../../../General/CalendarRangeInput'

const BaseDD = [
  { value: "DOS", display: "Date of Service" },
  { value: "EntryDate", display: "Entry Date" },
  { value: "SubmittedDate", display: "Submitted" }
]

const API_URL = enumUtil.controller.Dashboard

const BillingPerformance = memo((props) => {
  const { reloadData } = props;

  const DEFAULT_SEARCH_MODAL = {
    "DateTo": "",
    "DateFrom": "",
  }
  const getLastMonthRange = () => {
    try {
      const now = new Date();
      const firstDayLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastDayLastMonth = new Date(now.getFullYear(), now.getMonth(), 0);

      const format = (d) => {
        if (!(d instanceof Date) || isNaN(d)) return "";
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        const yyyy = d.getFullYear();
        return `${mm}/${dd}/${yyyy}`;
      };

      return {
        DateFrom: format(firstDayLastMonth) || "",
        DateTo: format(lastDayLastMonth) || "",
      };
    } catch {
      return { DateFrom: "", DateTo: "" };
    }
  };
  const [dateRange, setDateRange] = useState(null);
  const [searchParamDate, setSearchParamDate] = useState(getLastMonthRange());
  const [applyDate, setApplyDate] = useState(false);
  const [billingPerformanceData_1, setBillingPerformanceData_1] = useState([])
  const [billingPerformanceData_0, setBillingPerformanceData_0] = useState([])
  const [billingPerformanceData_2, setBillingPerformanceData_2] = useState([])
  const [isLoadingBillingPerformance, setIsLoadingBillingPerformance] = useState(false)
  const [baseOnBillingPerformance, setBaseOnBillingPerformance] = useState('Date of Service')
  const [reloadSuperSearch, setReloadSuperSearch] = useState(false)

  // fetch-only — no closures over stale filter state, value is always passed in fresh
  // const fetchBillingPerformance = (value, part) => {
  //     let searchParam = 
  //         part === 'Billing Performance 1' ? 
  //             "Clean Claim Rate, First-Pass Resolution, Denial Rate, Net Collection Rate" :
  //         part === 'Billing Performance 2' ? 
  //             "Days in AR, Submission Lag, Payment Velocity, Re-Submission" :
  //         part === 'Billing Performance 0' ? 
  //             "Days in AR, Submission Lag, Payment Velocity, Re-Submission" : '';

  //     return ServerRequestProtected(API_URL + '/BillingPerformance', 'post', {
  //     TableName: enumUtil.enumAPITableName.DashboardBillingPerformance,
  //     SearchParam: searchParam,
  //     ...value
  //     })
  // }

  const LoadData = (part) => {
    setIsLoadingBillingPerformance(true)
    setBillingPerformanceData_0([])
    setBillingPerformanceData_1([])
    setBillingPerformanceData_2([])
    let searchParam =
      part === 'Billing Performance 0' ?
        "Total Amount, Billed Amount, Not Billed Amount, Unclaimed Appointments, Payments Received, Payments Pending, Denied, Provider Write-Off" :
        part === 'Billing Performance 1' ?
          "Clean Claim Rate, First-Pass Resolution, Denial Rate, Net Collection Rate" :
          part === 'Billing Performance 2' ?
            "Days in AR, Submission Lag, Payment Velocity, Re-Submission" : '';

    ServerRequestProtected(API_URL + '/BillingPerformance', 'post', {
      "TableName": enumUtil.enumAPITableName.DashboardBillingPerformance,
      "SearchParam": searchParam,
      ...searchBillingPerformanceFilterModal
    }).then((response) => {
      if (part === 'Billing Performance 0') setBillingPerformanceData_0(response)
      if (part === 'Billing Performance 1') setBillingPerformanceData_1(response)
      if (part === 'Billing Performance 2') setBillingPerformanceData_2(response)
      // 'Billing Performance' (from handleApply) → refresh both parts
      // if (part === 'Billing Performance') {
      //     setBillingPerformanceData_1(response)
      //     setBillingPerformanceData_2(response)
      // }
    }).catch(() => {
    }).finally(() => setIsLoadingBillingPerformance(false))
  }

  let [
    setOpenBillingPerformance,
    searchBillingPerformanceFilterModal,
    billingPerformanceFilterDiv,
    setBasedOnDateBillingPerformance,
    basedOnDateBillingPerformance,
  ] = useDashboardFilterHook(
    LoadData,
    'Billing Performance',
    () => { },
    null,
    searchParamDate,
    () => {
      // -- onReset -- //
      setBaseOnBillingPerformance('Date of Service');
      setDateRange(null);
      setSearchParamDate({ DateFrom: "", DateTo: "" });
      setReloadSuperSearch(!reloadSuperSearch);
      if (searchParamDate?.DateFrom || searchParamDate?.DateTo) {
        setApplyDate(true)
      }
    }
  )

  useEffect(() => {
    LoadData('Billing Performance 0')
    LoadData('Billing Performance 1')
    LoadData('Billing Performance 2')
  }, [basedOnDateBillingPerformance, reloadData])

  useEffect(() => {
    if (!applyDate) return;
    LoadData('Billing Performance 0')
    LoadData('Billing Performance 1')
    LoadData('Billing Performance 2')
    setApplyDate(false);
  }, [applyDate])

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'BaseOnBillingPerformance') setBaseOnBillingPerformance(value)
  }

  const handleSelectedData = (selectedData, name, type) => {
    if (type === 'client' && selectedData) {
      if (name === 'BaseOnBillingPerformance') {
        setBaseOnBillingPerformance(selectedData.display)
        setBasedOnDateBillingPerformance(selectedData.value + "")
        if (selectedData.value !== basedOnDateBillingPerformance) {
          setIsLoadingBillingPerformance(true)
        }
      }
    } else {
      if (name === 'BaseOnBillingPerformance') setBaseOnBillingPerformance('')
    }
    return selectedData
  }

  ////////////////// Date Range ////////////////////
  const getCurrentDateRange = (dateFrom, dateTo) => {
    return {
      formattedStartDate: searchParamDate?.DateFrom || null,
      formattedEndDate: searchParamDate?.DateTo || null
    };
  };

  useEffect(() => {
    const currentWeekDates = getCurrentDateRange();
    if (currentWeekDates?.formattedStartDate) {
      setDateRange(`${currentWeekDates.formattedStartDate}-${currentWeekDates.formattedEndDate}`);
    }
  }, []);
  //////////////////////////////////////////////////

  return (
    <>
      <div className="align-items-center br-bottom-1 d-flex justify-content-between mb-06-px pb-1-5 position-relative za_br_light">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">KPI's</p>
          <p className="px-1-5 text fs-11 font-m validate-color beta-btn">Beta</p>
        </div>
      </div>
      <div className="align-items-center br-bottom-1 d-flex justify-content-between mb-06-px pb-1-5 position-relative za_br_light">
        <div className="d-flex align-items-center gap-2">
          <p className="heading text-black fs-15">Billing Summary & Performance</p>
        </div>

        <span className="ar_dash-filter d-flex align-items-center gap-2 pe-10">
          {isLoadingBillingPerformance ? (
            <div className="ar-small-loader last_loader">
              <div className="circle circle1"></div>
              <div className="circle circle2"></div>
            </div>
          ) : <></>}
          <div className="w-130px">
            <SuperSearchList
              type="client"
              id='BaseOnBillingPerformance'
              name='BaseOnBillingPerformance'
              searchValue={baseOnBillingPerformance}
              data={BaseDD}
              onChange={(e) => handleChange(e)}
              getSelectedData={handleSelectedData}
              icon={'Simple'}
              sup_btn='sup_btn'
              sup_inp='superSearchVisitInp'
            />
          </div>
          <div className="DatePicker-No-Round w-185px">
            <CalendaRangeInput
              key={reloadSuperSearch}
              searchParam={searchParamDate}
              setSearchParam={setSearchParamDate}
              defaultDates={dateRange}
              options={['Date']}
              label={false}
              setApplyDate={setApplyDate}
            />
          </div>
          <div className="app_tooltip left">
            <i className="icon-Icon-awesome-filter fs-16" onClick={() => setOpenBillingPerformance(prev => !prev)}></i>
            <p className="tool_tip xsm_text text-light">Filters</p>
          </div>
        </span>
      </div>

      <div className="d-flex flex-column gap-2">
        <div className="d-flex gap-2 row-gap-10 flex-wrap ar-Billing-Performance-widge">
          {billingPerformanceData_0?.map((item, i) => (
            <BillingSummaryCard key={`bs0-${item?.Group ?? i}`} index={i} item={item} />
          ))}
        </div>
        <div className="d-flex gap-2 row-gap-10 flex-wrap ar-Billing-Performance-widge">
          {billingPerformanceData_1?.map((item, i) => (
            <BillingPerformanceCard key={`bp1-${item?.Group ?? i}`} index={i} item={item} />
          ))}
          {billingPerformanceData_2?.map((item, i) => (
            <BillingPerformanceCard key={`bp2-${item?.Group ?? i}`} index={i} item={item} />
          ))}
        </div>
      </div>
      {billingPerformanceFilterDiv}
    </>
  )
})

export default BillingPerformance

const BillingSummaryCard = memo(({index, item }) => {
  return (
    <div className={`card_tabs w-25 py-2 px-1-5 ${index < 3 ? 'cursor-pointer' : ''}`}>
      <div className="d-flex align-items-center justify-content-between">
        <p className="text text-black fs-11">{item?.Group}</p>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <p className='heading fs-15 text-black'>{item?.Field1}</p>
        <p className='text fs-10'>{item?.Field2}</p>
      </div>
    </div>
  )
})
const BillingPerformanceCard = memo(({ index, item }) => {
  console.log('index', index)
  return (
    <div className={`card_tabs w-25  ${index === 3 ? 'flip-tooltip' : ''}`} >
      <div className="pt-2 px-1-5">
        <div className="d-flex align-items-center justify-content-between">
          <p className="text text-black">{item?.Group}</p>
          <div className="app_tooltip bottom wide-content">
            <SimpleQuestionIcon />
            <div className="tool_tip d-block">
              <p className='heading fs-11 ar-dark-color br-bottom-1 za_br_light pb-2px mb-2px'>{item?.Group}</p>
              <p className='text fs-10 pb-1 text-wrap'>{item?.Definition}</p>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <p className='heading fs-16 text-black'>{item?.Percentage}</p>
          <p className={`pill px-1 ${item?.TargetColor === 'Red' ? 'Denied' : 'Paid'} fst-normal`}>{item?.Target}</p>
        </div>
      </div>
      <div className="footer-bg mt-2">
        <p className='text'>{item?.Summary}</p>
      </div>
    </div>
  )
})